<template>
	<div class="form__group">
		<multiselect
            :options="results"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="companyName"
            track-by="id"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :multiple="multiple"
            :options-limit="10"
            :show-labels="false"
            @search-change="onSearchChange"
            v-model="selected"
            :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }"
        >
			<span slot="noOptions">Type to search opportunities...</span>
		</multiselect>

		<label class="form__label">{{ label }}</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import API from '@api';
	import AjaxSelect from './AjaxSelect';

	export default {
		name: 'FormControlOpportunity',
		mixins: [AjaxSelect],
		props: {
			label: {
				type: String,
				default: 'Select opportunity',
			},
			placeholder: {
				type: String,
				default: 'Select opportunity...',
			}
		},
		methods: {
			async search(query) {
                try {
                    const { data } = await API.getOpportunities({ query });
                    this.results = data;
                } catch (error) {
                    console.warn(error);
                } finally {
                    this.loading = false;
                }
			},
			getItemFromCache(id) {
				return this.$store.getters['selectCache/getOpportunity'](id);
			},
			addItemToCache(item) {
				this.$store.commit('selectCache/addOpportunity', item);
			},
			/**
			 * On load we only have the opportunity id (this.value), not the full object needed
			 * to display it in the multiselect. Use the cache if we have it, otherwise fetch it.
			 */
			async setInitialValue() {
				if (!this.value) {
					return;
				}

				const cached = this.getFromCache(this.value);

				if (cached) {
					this.selected = cached;
					return;
				}

				try {
					const data = await API.getOpportunity(this.value);
					this.addItemToCache(data);
					this.selected = data;
				} catch (error) {
					console.warn(error);
				}
			}
		},
	}
</script>
